import AppStoreBadge from '~/src/common/assets/app-store-badge.svg';
import GooglePlayBadge from '~/src/common/assets/google-play-badge.svg';
import I18n from '~/src/common/services/I18n';

import QrCode from '../../block/qrCode/Component';
import { PropsFromInputs } from '../../types';

import { Container, QR_SIZE, Textual, Visual } from './layout';

const APP_STORE_URL = 'https://apps.apple.com/fr/app/mon-marché-courses-en-ligne/id1477200978';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=fr.monmarche.app&pli=1';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ title, text, phone, link }: Props) => {
  return (
    <Container>
      {phone ? (
        <Visual>
          <img src={phone} alt={I18n.t('builder.section.download.image')} />
          {link ? (
            <div>
              <span>{I18n.t('builder.section.download.arrow')}</span>
              <svg viewBox="0 0 115 166">
                <path d="M78.95 1.31A2 2 0 0 0 76 4.01l2.95-2.7ZM1.09 148.72a2 2 0 0 0-.06 2.83l12.49 12.97a2 2 0 1 0 2.88-2.78L5.3 150.22l11.53-11.1a2 2 0 1 0-2.78-2.88L1.1 148.72ZM76 4.02c34.2 37.18 41.41 73.66 27.82 100.36-13.63 26.78-48.68 44.78-101.3 43.78l-.08 4c53.37 1.01 90.32-17.24 104.94-45.96 14.66-28.8 6.36-67.07-28.43-104.89L76 4.01Z" />
              </svg>
              <QrCode link={link} size={QR_SIZE} />
            </div>
          ) : null}
        </Visual>
      ) : null}
      <Textual>
        <p>
          <strong>{title}</strong>
          <span>{text}</span>
        </p>
        <footer>
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            <AppStoreBadge />
          </a>
          <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
            <GooglePlayBadge />
          </a>
        </footer>
      </Textual>
    </Container>
  );
};
